import hualongTrace from './hualong-trace'

const {
  getHualongProducts,
  parseProductIdFromHash
} = hualongTrace

function currentEnvironment() {
  return process.env.VUE_APP_LEGACY_UUID_ENV
}

/** 判断是否为华龙旧版产品 ID（35-42）。 */
export function isLegacyProductId(value) {
  const legacyId = Number(value)
  return getHualongProducts(currentEnvironment())
    .some(product => product.legacyId === legacyId)
}

/** 获取华龙旧版产品名称，主要用于诊断日志。 */
export function getLegacyProductName(value) {
  const legacyId = Number(value)
  const product = getHualongProducts(currentEnvironment())
    .find(item => item.legacyId === legacyId)
  return product ? `${product.name}（${product.spec}）` : '未知产品'
}

/**
 * 解析 hash 路由中的产品参数。
 *
 * 支持 product_id、华龙旧版 ID、华龙 ERP goods_id 以及普通 product 参数。
 */
export function parseProductId() {
  return parseProductIdFromHash(window.location.hash, currentEnvironment())
}

export { parseProductIdFromHash }
